export default "__VITE_ASSET__l_JZ2DDh__"